var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"voice__filters"}),_vm._v(" "),_c('div',{staticClass:"voice__items"},[_c('div',{staticClass:"voice__items--container"},[_c('div',{staticClass:"voice__items--container-record"},[_c('aplayer',{attrs:{"autoplay":"","music":{
            artist: 'reza pishro',
            title: ' ',
            url:
              'https://dl.mokhtalefmusic.com/music/1396/12/29/Reza%20Pishro%20-%20Niloofare%20Abi%20%28New%20Version%29.mp3',
            cover:
              'https://lastfm.freetls.fastly.net/i/u/ar0/718e23e8e1d612a5ee10b105b2c12b35.jpg',
            theme: '#ef3954'
          }}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice__demo"},[_c('h1',{staticClass:"voice__demo--h1"},[_vm._v("جزييات بیشتر از محصول")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f48a8f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/voice/voice.vue
// module id = 478
// module chunks = 0